/**
 * 判断多选条件是否存在
 * @param condition 条件str
 * @param list 试题list
 * @return Boolean
 */
export const IsInclude = (list, condition) => {
    if (!condition) return false
    let result = false
    let codeAndRow = condition.split(':')[0] // 试题号、行号
    let code = codeAndRow.split('_')[0] // 试题编码
    let orderNumArr = condition.split(':')[1].split(',')
    let sonOrderNum = codeAndRow.split('_').length > 1 ? codeAndRow.split('_')[1] : undefined // 行编号
    // console.log(code, sonOrderNum, orderNumArr)
    list.forEach(info => {
        if (code == info.quesCode && info.bindIsShow && info.isShow) {
            let selectedNum = 0 // 答案中已选的个数
            switch(info.questionsTypeId) {
                case '10':
                    info.optionList.forEach(op => {
                        if (orderNumArr.indexOf(op.orderNum.toString()) != -1 
                            && info.userAnswerArr.indexOf(op.oid) != -1
                        ) {
                            selectedNum++
                        }
                    })
                    if (selectedNum == orderNumArr.length) {
                        result = true
                    }
                    break
                case '20':
                    info.questionsSonList.forEach(son => {
                        if (sonOrderNum == son.orderNum) {
                            son.optionList.forEach(op => {
                                if (orderNumArr.indexOf(op.orderNum.toString()) != -1 && 
                                    info.userAnswerArr.length > 0 &&
                                    info.userAnswerArr[son.orderNum - 1].value.indexOf(op.oid) != -1
                                ) {
                                    selectedNum++
                                }
                            })
                        }
                    })
                    if (selectedNum == orderNumArr.length) {
                        result = true
                    }
                    break
            }
        } 
    })
    return result;
}
